// extracted by mini-css-extract-plugin
export default {"main":"styles_main__DDuM9","title":"styles_title__2-dwb","faculties":"styles_faculties__63kOh","zoom":"styles_zoom__ihkZL","faculties-mobile":"styles_faculties-mobile__hdgJX"};